<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <!-- <breadcrumb :page="$t('form.setting.statusList')"></breadcrumb> -->

        <div class="content">
            <div class="container-fluid pt-5">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="row">
                    <div class="col-md-8">
                        <div class="card">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.hrStatusList')}}</div>
                            </div>
                            <div class="card-body table-responsive p-0">
                                <table class="table table-hover" v-if="statuses.length">
                                    <thead>
                                        <tr class="header">
                                            <th>{{$t('form.setting.hrName')}}</th>
                                            <th>{{$t('form.setting.hrActive')}}</th>
                                            <th class="text-right">{{$t('form.setting.action')}}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(status, index) in statuses" :key="index">
                                            <td>{{status.Name}}</td>
                                            <td>
                                                <b-badge variant="success" v-if="status.Active">{{$t('form.setting.hrYes')}}</b-badge>
                                                <b-badge variant="danger" v-else>{{$t('form.setting.hrNo')}}</b-badge>
                                            </td>

                                            <td class="text-right">
                                                <button v-if="permissions.editSettingsHrstatuses"
                                                    class="btn btn-info btn-sm" @click="edit(index)">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button v-if="permissions.deleteSettingsHrstatuses"
                                                    class="btn btn-danger btn-sm" @click="remove(index)">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                            </div>

                            <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                                @paginate="paginate()">
                            </pagination>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="card" v-if="toggleForm">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.hrStatusCreate')}}</div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>{{$t('form.setting.hrName')}}</label>
                                    <input type="text" class="form-control" v-model="name">
                                </div>

                                <div class="form-group">
                                    <b-form-checkbox v-model="active">
                                        {{$t('form.setting.hrActive')}}
                                    </b-form-checkbox>
                                </div>

                                <b-button variant="primary" @click="submit">{{$t('button.save')}}</b-button>
                            </div>
                        </div>

                        <div class="card" v-else>
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.hrStatusEdit')}}</div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>{{$t('form.setting.hrName')}}</label>
                                    <input type="text" class="form-control" v-model="name">
                                </div>

                                <div class="form-group">
                                    <b-form-checkbox v-model="active">
                                        {{$t('form.setting.hrActive')}}
                                    </b-form-checkbox>
                                </div>

                                <b-button variant="primary" @click="update">{{$t('button.update')}}</b-button>
                                <b-button variant="outline-primary" @click="cancel">{{$t('button.cancel')}}</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions', 'dateFormat'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,
                toggleForm: true,

                pagination: {
                    current_page: 1
                },

                name: '',
                id: '',
                active: false,

                statuses: []
            }
        },

        mounted() {
            if (!this.permissions.viewSettingsHrstatuses) {
                return this.$router.push('/');
            }

            this.getStatuses();
        },

        methods: {

            getStatuses() {
                this.isLoading = true;

                axios
                    .get('/api/hr-statuses?page=' + this.pagination.current_page)
                    .then(response => {
                        this.statuses = response.data.data.data;
                        this.pagination = response.data.pagination;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            paginate() {
                this.getStatuses();
            },

            submit() {
                if (this.name == '') {
                    this.showAlert('Please add name to continue.', 'danger');
                    return;
                }

                this.clear();
                this.isLoading = true;

                axios
                    .post('/api/hr-statuses', {
                        Name: this.name,
                        Active: this.active
                    })
                    .then(response => {
                        if (response.data.success) {
                            this.name = '';
                            this.showAlert(response.data.message);
                            this.statuses.unshift(response.data.data);
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {

                        if (error.response.data.error) {
                            this.showAlert(error.response.data.message, 'danger');
                        }

                        this.isLoading = false;
                    })
            },

            edit(index) {
                this.active = this.statuses[index].Active;
                this.name = this.statuses[index].Name;
                this.id = this.statuses[index].id;
                this.toggleForm = false;
            },

            update() {
                if (this.name == '') {
                    this.showAlert('Please add name to continue.', 'danger');
                    return;
                }

                this.clear();
                this.isLoading = true;

                axios
                    .put(`/api/hr-statuses/${this.id}`, {
                        Name: this.name,
                        Active: this.active
                    })
                    .then(response => {
                        if (response.data.success) {
                            this.showAlert(response.data.message);
                            this.statuses.map(r => {
                                if (r.id == this.id) {
                                    // r.id = response.data.data.id;
                                    r.Active = response.data.data.Active;
                                    r.Name = response.data.data.Name;
                                }
                            });

                            this.cancel();
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.showAlert(error.response.data.message, 'danger');
                        }
                        this.isLoading = false;
                    })
            },

            cancel() {
                this.active = false;
                this.name = '';
                this.id = null;
                this.toggleForm = true;
            },

            remove(index) {
                if (confirm(this.$t('form.validation.delete'))) {

                    this.clear();
                    this.isLoading = true;

                    axios
                        .delete(`/api/hr-statuses/${this.statuses[index].id}`)
                        .then(response => {
                            if (response.data.success) {
                                this.showAlert(response.data.message);
                                this.statuses.splice(index, 1);
                            }

                            this.isLoading = false;
                        })
                        .catch(error => {
                            if (error.response.status === 422) {
                                this.showAlert(error.response.data.message, 'danger');
                            }

                            this.isLoading = false;
                        })
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },

            clear() {
                this.alert = false;
                this.message = '';
                this.alertClass = '';
            }
        }
    }

</script>
